"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateObjectInArray = exports.updateAccountInArray = exports.findIndexOfObject = exports.distinct = exports.appendEach = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var appendEach = exports.appendEach = function appendEach(arr, suffix) {
  return arr.filter(function (c) {
    return c;
  }).map(function (text) {
    return text + suffix;
  });
};
var distinct = exports.distinct = function distinct(array) {
  var keySelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
    return item;
  };
  var unique = new Map();
  var distinctArray = [];
  array.forEach(function (item) {
    var itemKey = keySelector(item);
    if (!unique.has(itemKey)) {
      distinctArray.push(item);
      unique.set(itemKey, item);
    }
  });
  return distinctArray;
};
var findIndexOfObject = exports.findIndexOfObject = function findIndexOfObject(array, key, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][key] === value) {
      return i;
    }
  }
  return undefined;
};
var updateObjectInArray = exports.updateObjectInArray = function updateObjectInArray(array, action) {
  if (typeof action.index !== 'number') {
    return [].concat(_toConsumableArray(array), [action.item]);
  }
  return array.map(function (item, index) {
    if (index !== action.index) {
      return item;
    }
    return _objectSpread(_objectSpread({}, item), action.item);
  });
};
var updateAccountInArray = exports.updateAccountInArray = function updateAccountInArray(accounts, payload) {
  if (payload.item && payload.item.AccountId) {
    // Try to find the account by AccountId
    var matchingAccountIndex = accounts.findIndex(function (account) {
      return account.AccountId === payload.item.AccountId;
    });

    // If found, update that specific account
    if (matchingAccountIndex >= 0) {
      return accounts.map(function (account, index) {
        if (index !== matchingAccountIndex) return account;
        return _objectSpread(_objectSpread({}, account), payload.item);
      });
    }
  }
  return accounts;
};